import { render, staticRenderFns } from "./priceSetting.vue?vue&type=template&id=5b9cc85d&"
import script from "./priceSetting.vue?vue&type=script&lang=js&"
export * from "./priceSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9cc85d')) {
      api.createRecord('5b9cc85d', component.options)
    } else {
      api.reload('5b9cc85d', component.options)
    }
    module.hot.accept("./priceSetting.vue?vue&type=template&id=5b9cc85d&", function () {
      api.rerender('5b9cc85d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/priceSetting.vue"
export default component.exports